import React, {useState} from 'react';
import {Spring} from 'react-spring/renderprops';
import styled from 'styled-components';
import { useHistory } from "react-router-dom";
import {ArrowContainer} from "react-tiny-popover";
import PopoverInner from "../PopoverInner";
import Popover from "react-tiny-popover";

const StyledG = styled.g`
  cursor: pointer;
  path {
    transform-origin: left;
  }
`;

export default function CoursePhasesSvg(props) {

  const [hover, setHover] = useState(null)
  const data = props.data;
  let history = useHistory();

  const subItems = data[2].description.value.match(/<strong>(.*?)<\/strong>/g);
  const stripRegex = /(<[^>]+>|<[^>]>|<\/[^>]>)/g;
  subItems.forEach( (item, i) => {
    let newItem = item.replace(stripRegex , ' ');
    subItems[i] = newItem;
  });

  return (
      <svg width="100%" height="100%" viewBox="0 -20 1043 191" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
          {/* Generator: Sketch 59.1 (86144) - https://sketch.com */}
          <title>E4H/Caterpillar</title>
        <desc>Created with Sketch.</desc>
        <g  stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <StyledG id="Partner"
               onMouseEnter={ () => setHover(data[0].name)}
               onMouseLeave={ () => setHover(null)}
               onFocus={() => setHover(data[0].name)}
               onBlur={ () => setHover(null) }
               role={'link'}
               tabIndex={0}
               onClick={ () => history.push(`/activities?phase=${data[0].name}`)}
            >
              <Spring
                from={{ scale: 1, opacity: 0.5 }}
                to={{ scale: hover === data[0].name ? 1.15 : 1, opacity: hover === data[0].name ? 0.65 : 0.5 }}>
                {props => (
                  <path
                    d="M0,83.0491435 C64.4483367,27.6830478 113.448337,0 147,0 C180.551663,0 229.551663,27.6830478 294,83.0491435 C229.432292,135.016381 180.432292,161 147,161 C113.567708,161 64.5677083,135.016381 0,83.0491435 Z"
                    fillOpacity={props.opacity}
                    fill="#739D63"
                    style={{
                      transform: `scaleY(${props.scale})`,
                      WebkitTransform: `scaleY(${props.scale})`,
                      MsTransform:`scaleY(${props.scale})`
                    }}
                  />
                )}
              </Spring>
              <Popover
                isOpen={hover === data[0].name}
                // isOpen={true}
                position={'bottom'} // preferred position
                disableReposition={true}
                content={({ position, targetRect, popoverRect }) => (
                  <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                    position={position}
                    targetRect={targetRect}
                    popoverRect={popoverRect}
                    arrowColor={'white'}
                    arrowSize={10}
                    arrowStyle={{ pointerEvents: 'none' }}
                  >
                    <PopoverInner
                      data={data[0]}
                    >
                    </PopoverInner>
                  </ArrowContainer>
                )}
              >
              <text id="Who's-our-partner?" fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#0A1F44">
                <tspan x={78} y={89}>{data[0].name}</tspan>
              </text>
              </Popover>
            </StyledG>
            <StyledG id="Project"
               transform="translate(227.000000, 0.000000)"
               onMouseEnter={ () => setHover(data[1].name)}
               onMouseLeave={ () => setHover(null)}
               onFocus={() => setHover(data[1].name)}
               onBlur={ () => setHover(null) }
               role={'link'}
               tabIndex={0}
               onClick={ () => history.push(`/activities?phase=${data[1].name}`)}
            >
              <Spring
                from={{ scale: 1, opacity: 0.5 }}
                to={{ scale: hover === data[1].name ? 1.15 : 1, opacity: hover === data[1].name ? 0.65 : 0.5 }}>
                {props => (
                  <path
                    d="M0,83.0491435 C72.9976058,27.6830478 128.497606,0 166.5,0 C204.502394,0 260.002394,27.6830478 333,83.0491435 C259.867188,135.016381 204.367187,161 166.5,161 C128.632812,161 73.1328125,135.016381 0,83.0491435 Z"
                    fillOpacity={props.opacity}
                    fill="#739D63"
                    style={{transform: `scaleY(${props.scale})`}}
                  />
                )}
              </Spring>
              <Popover
                isOpen={hover === data[1].name}
                // isOpen={true}
                position={'bottom'} // preferred position
                disableReposition={true}
                content={({ position, targetRect, popoverRect }) => (
                  <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                    position={position}
                    targetRect={targetRect}
                    popoverRect={popoverRect}
                    arrowColor={'white'}
                    arrowSize={10}
                    arrowStyle={{ pointerEvents: 'none' }}
                  >
                    <PopoverInner
                      data={data[1]}
                    >
                    </PopoverInner>
                  </ArrowContainer>
                )}
              >
              <text id="What’s-our-project?" fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#0A1F44">
                <tspan x={99} y={89}>{data[1].name}</tspan>
              </text>
              </Popover>
            </StyledG>
            <StyledG id="Product"
               transform="translate(482.000000, 0.000000)"
               onMouseEnter={ () => { setHover(data[2].name)}}
               onMouseLeave={ () => setHover(null)}
               onFocus={() => setHover(data[2].name)}
               onBlur={ () => setHover(null) }
               role={'link'}
               tabIndex={0}
               onClick={ () => history.push(`/activities?phase=${data[2].name}`)}
            >
              <Spring
                from={{ scale: 1, opacity: 0.5 }}
                to={{ scale: hover === data[2].name ? 1.15 : 1, opacity: hover === data[2].name ? 0.65 : 0.5 }}>
                {props => (
                  <path
                    d="M0,83.0491435 C122.977949,27.6830478 216.477949,0 280.5,0 C344.522051,0 438.022051,27.6830478 561,83.0491435 C437.794271,135.016381 344.294271,161 280.5,161 C216.705729,161 123.205729,135.016381 0,83.0491435 Z"
                    id="Prodcut"
                    fillOpacity={props.opacity}
                    fill="#739D63"
                    style={{transform: `scaleY(${props.scale})`}}
                  />
                )}
              </Spring>
              <text id="What’s-our-product?" fontFamily="Inter-Medium, Inter" fontSize={14} fontWeight={400} line-spacing={16} fill="#0A1F44">
                <tspan x="208.01598" y="73.7272727">{data[2].name}</tspan>
              </text>
              <Popover
                isOpen={hover === data[2].name}
                // isOpen={true}
                position={'bottom'} // preferred position
                disableReposition={true}
                content={({ position, targetRect, popoverRect }) => (
                  <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                    position={position}
                    targetRect={targetRect}
                    popoverRect={popoverRect}
                    arrowColor={'white'}
                    arrowSize={10}
                    arrowStyle={{ pointerEvents: 'none' }}
                  >
                    <PopoverInner
                      data={data[2]}
                    >
                    </PopoverInner>
                  </ArrowContainer>
                )}
              >
              <text id="play-prototype-pilot" fontFamily="Inter-Regular, Inter" fontSize={12} fontWeight="normal" line-spacing={16} fill="#0A1F44">
                <tspan x="186.818182" y="98.9090909">
                  { subItems.map( item => {
                    return(
                      item
                    )
                  })}
                </tspan>
              </text>
              </Popover>
            </StyledG>
        </g>
      </svg>
  );
}
